import React,{useEffect,useMemo,useState} from 'react';
import {apiRequest,getEntityId,unwrapCollection} from '../../api/client';
import {getDifficulty} from '../../utils/cards';

const difficultyGroups=['Beginner','Intermediate','Advanced'];

function ProgressPage() {
  const [data,setData]=useState({cards: [],progress: []});
  const [error,setError]=useState('');

  useEffect(()=> {
    let active=true;

    Promise.all([
      apiRequest('/flashcards',{auth: false}),
      apiRequest('/progress')
    ]).then(([cardPayload,progressPayload])=> {
      if (!active) return;

      setData({
        cards: unwrapCollection(cardPayload,['flashcards','items','results']),
        progress: unwrapCollection(progressPayload,['progress','items','results'])
      });
    }).catch((requestError)=> {
      if (active) setError(requestError.message);
    });

    return ()=> {
      active=false;
    };
  },[]);

  const groups=useMemo(()=> {
    const progressByCard=new Map(
      data.progress.map((item)=> [
        String(
          getEntityId(item.flashcard_id) ||
          item.card_id ||
          item.flashcard_id
        ),
        item
      ])
    );

    return data.cards.reduce((result,card)=> {
      const progress=progressByCard.get(String(getEntityId(card)));
      const status=progress?.status;

      if (status==='learning' || status==='known') {
        const difficulty=getDifficulty(card.target_band);
        result[status][difficulty].push(card.front_text);
      }

      return result;
    },{
      learning: {Beginner: [],Intermediate: [],Advanced: []},
      known: {Beginner: [],Intermediate: [],Advanced: []}
    });
  },[data]);

  const columns=[
    {key: 'learning',label: 'Learning'},
    {key: 'known',label: 'Known'}
  ];

  const totalWords=(status)=> difficultyGroups.reduce(
    (total,difficulty)=> total+groups[status][difficulty].length,
    0
  );

  return (
    <section>
      <style>{`
        .difficulty-sections {
          display: grid;
          gap: 0;
        }

        .difficulty-section {
          border-bottom: 1px solid #edf1f0;
          padding: 1rem;
        }

        .difficulty-section:last-child {
          border-bottom: 0;
        }

        .difficulty-section h3 {
          color: var(--muted);
          font-size: 0.72rem;
          letter-spacing: 0.08em;
          margin-bottom: 0.55rem;
          text-transform: uppercase;
        }

        .difficulty-section .muted {
          font-size: 0.78rem;
          padding: 0.15rem 0;
        }

        .compact-word-list {
          color: var(--ink);
          font-size: 0.88rem;
          line-height: 1.7;
          overflow-wrap: anywhere;
        }
      `}</style>

      <header className="page-heading">
        <div>
          <span className="eyebrow">Learning overview</span>
          <h1>My progress</h1>
          <p>Keep track of the words you are learning and know.</p>
        </div>
      </header>

      {error && <div className="error-banner">{error}</div>}

      <div className="progress-groups simplified-progress">
        {columns.map((column)=> (
          <section className="progress-group" key={column.key}>
            <header>
              <h2>{column.label}</h2>
              <span>{totalWords(column.key)}</span>
            </header>

            <div className="difficulty-sections">
              {difficultyGroups.map((difficulty)=> {
                const words=groups[column.key][difficulty];

                return (
                  <div className="difficulty-section" key={difficulty}>
                    <h3>{difficulty}</h3>

                    {words.length ? (
                      <p className="compact-word-list">
                        {words.join(',')}
                      </p>
                    ) : (
                      <p className="muted">No words yet.</p>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </section>
  );
}

export default ProgressPage;